<script lang="ts">
  import OperationsManager from '@neuhaus/operations-manager'
  import Base from '@factry/base'
  import DowntimeManager from '@factry/downtime-manager'
  import EquipmentManager from '@factry/equipment-manager'
  import InstructionManager from '@factry/instruction-manager'
  import LabelManager from '@factry/label-manager'
  import MaterialManager from '@factry/material-manager'
  import MessageQueueManager from '@factry/message-queue-manager'
  import MPSManager from '@factry/mps-manager'
  import OrderManager from '@factry/order-manager'
  import ShiftManager from '@factry/shift-manager'
  import WasteManager from '@factry/waste-manager'
</script>

<Base
  options={[
    OperationsManager, InstructionManager, DowntimeManager, EquipmentManager, OrderManager,
    LabelManager, MaterialManager, MessageQueueManager, MPSManager, ShiftManager, WasteManager,
  ]}
/>
